import Repository from './Repository';

const resource = '/main-data';
export default {
  get() {
    const url = `${resource}`;
    return Repository.get(url);
  },
};
